import React from 'react';
import MIcon from './MIcon';
import { Button } from '../ui';

const TYPE_CONFIG = {
  new: { icon: 'add_circle', color: 'var(--una-blue)', bg: 'var(--una-blue-lt)', label: 'Nuevo' },
  fix: { icon: 'build',      color: '#15803D', bg: '#F0FDF4', label: 'Mejora' },
  imp: { icon: 'trending_up', color: '#7C3AED', bg: '#EDE9FE', label: 'Mejora' },
};

function ChangeItem({ change }) {
  const cfg = TYPE_CONFIG[change.type] || TYPE_CONFIG.imp;
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '6px 0' }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 4,
        fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 6,
        background: cfg.bg, color: cfg.color, flexShrink: 0, marginTop: 1,
        whiteSpace: 'nowrap',
      }}>
        <MIcon name={cfg.icon} size={11}/>{cfg.label}
      </span>
      <span style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>{change.text}</span>
    </div>
  );
}

export default function WhatsNew({ changelog, version, onDismiss }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 24,
    }} onClick={e => { if (e.target === e.currentTarget) onDismiss(); }}>
      <div style={{
        background: '#fff', borderRadius: 16, width: '100%', maxWidth: 560,
        maxHeight: '85vh', display: 'flex', flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0,0,0,.2)',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          padding: '24px 28px 20px', borderBottom: '1px solid #F3F4F6',
          background: 'linear-gradient(135deg, var(--una-blue) 0%, var(--una-blue-h) 100%)',
          display: 'flex', alignItems: 'center', gap: 14,
        }}>
          <div style={{
            width: 44, height: 44, borderRadius: 12, background: 'rgba(255,255,255,.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <MIcon name="new_releases" size={24} style={{ color: '#fff' }}/>
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#fff' }}>Novedades</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,.7)', marginTop: 2 }}>
              Versión {version} · HelpDesk TI
            </div>
          </div>
          <button onClick={onDismiss} style={{
            marginLeft: 'auto', background: 'rgba(255,255,255,.15)', border: 'none',
            borderRadius: 8, width: 32, height: 32, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
          }}>
            <MIcon name="close" size={18}/>
          </button>
        </div>

        {/* Changelog entries */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {changelog.map((entry, i) => (
            <div key={entry.version} style={{
              padding: '20px 28px',
              borderBottom: i < changelog.length - 1 ? '1px solid #F3F4F6' : 'none',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{
                  fontSize: 12, fontWeight: 700, padding: '3px 9px', borderRadius: 8,
                  background: i === 0 ? 'var(--una-blue)' : '#F3F4F6',
                  color: i === 0 ? '#fff' : '#6B7280',
                }}>
                  v{entry.version}
                </span>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>{entry.title}</span>
                <span style={{ fontSize: 11, color: '#9CA3AF', marginLeft: 'auto', flexShrink: 0 }}>
                  {entry.date}
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {entry.changes.map((c, j) => <ChangeItem key={j} change={c}/>)}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 28px', borderTop: '1px solid #F3F4F6',
          display: 'flex', justifyContent: 'flex-end',
        }}>
          <Button variant="primary" onClick={onDismiss} style={{padding:'9px 24px'}}>
            Entendido
          </Button>
        </div>
      </div>
    </div>
  );
}
